import { Navigate, Route, Routes } from "react-router-dom";
import { BadgesView } from "../badges";

export function BadgesShell() {
  return (
    <Routes>
      <Route path="/" element={<BadgesView />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
}

export default BadgesShell;
